// firebaseMobile.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const mobileApp = initializeApp(
  {
    apiKey: process.env.REACT_APP_MOBILE_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_MOBILE_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_MOBILE_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_MOBILE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MOBILE_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_MOBILE_FIREBASE_APPID,
  },
  "mobile-app" // nom d'instance
);

export const mobileDb = getFirestore(mobileApp);
export const mobileStorage = getStorage(mobileApp);
export default mobileApp;
